import { gql } from 'apollo-boost'

const SCRAPING_TAGS = gql`
  query scrapingTags {
    scrapingTags {
      id
      name
      type
    }
  }
`

export default SCRAPING_TAGS
